import useTaxCustomer from './useTaxCustomer'
// src/features/taxContext/PajakContextBar.js
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../hooks/useAuth'
import {
  selectCurrentTaxpayerId,
  setCurrentTaxpayerId,
  selectCurrentTaxYear,
  setCurrentTaxYear,
} from './taxContextSlice'

import TaxpayerContextSelector from './TaxpayerContextSelector'
import TaxYearSelector from './TaxYearSelector'

const PajakContextBar = ({
  taxpayers = [],
  isLoadingTaxpayers = false,
  onApply, // callback to parent (TaxDashboard)
}) => {
  const dispatch = useDispatch()

  const { getAppAccess, hasAppRole, isGlobalAdmin } = useAuth()

  const pajakAccess = getAppAccess('PAJAK_AUTOMATION')

  const customerId = useTaxCustomer() ?? '-'
  const taxpayerIdFromScope = pajakAccess?.scope?.taxpayer_id ?? null

  const isTenantAdmin = hasAppRole('PAJAK_AUTOMATION', 'TENANT_ADMIN')
  const isTaxPayer = hasAppRole('PAJAK_AUTOMATION', 'TAX_PAYER')
  const isTaxpayerOnly = !isGlobalAdmin && !isTenantAdmin && isTaxPayer

  // 🔹 global (redux)
  const currentTaxpayerId = useSelector(selectCurrentTaxpayerId)
  const currentTaxYear = useSelector(selectCurrentTaxYear)

  // 🔹 local draft state (important for Apply pattern)
  const [draftTaxpayerId, setDraftTaxpayerId] = useState(currentTaxpayerId)
  const [draftTaxYear, setDraftTaxYear] = useState(currentTaxYear)

  // sync redux → local (when external change happens)
  useEffect(() => {
    setDraftTaxpayerId(currentTaxpayerId)
  }, [currentTaxpayerId])

  useEffect(() => {
    setDraftTaxYear(currentTaxYear)
  }, [currentTaxYear])

  const handleApply = () => {
    dispatch(setCurrentTaxpayerId(draftTaxpayerId))
    dispatch(setCurrentTaxYear(draftTaxYear))

    if (onApply) {
      onApply({
        taxpayer_id: draftTaxpayerId,
        tax_year: draftTaxYear,
      })
    }
  }

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        
        {/* LEFT: Context controls */}
        <div className="grid gap-4 md:grid-cols-2">
          
          {/* Taxpayer */}
          <TaxpayerContextSelector
            taxpayers={taxpayers}
            isLoading={isLoadingTaxpayers}
            className="w-full"
            showLabel
            autoSelectFirst={false}
            value={draftTaxpayerId}
            onChange={setDraftTaxpayerId}
          />

          {/* Tax Year */}
          <TaxYearSelector
            value={draftTaxYear}
            onChange={setDraftTaxYear}
          />
        </div>

        {/* RIGHT: Apply button */}
        <div className="flex items-end">
          <button
            onClick={handleApply}
            className="rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-slate-800"
          >
            Apply
          </button>
        </div>
      </div>

      {/* 🔹 Scope Info */}
      <div className="mt-4 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800">
        <div className="font-semibold">Pajak Scope</div>
        <div>
          customer_id: <span className="font-semibold">{customerId}</span>
          {!isGlobalAdmin && taxpayerIdFromScope && (
            <>
              {' '}| taxpayer_id: <span className="font-semibold">{taxpayerIdFromScope}</span>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export default PajakContextBar